import React from 'react';
import { Avatar } from '../primitives/Avatar';

interface UserChipProps {
  name: string | null | undefined;
  subtitle?: string | null;
  avatarSrc?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Avatar + name (+ optional subtitle) inline block.
 * Used in table cells, lists, anywhere a person is referenced.
 */
export const UserChip: React.FC<UserChipProps> = ({ name, subtitle, avatarSrc, size = 'md', className = '' }) => {
  const avatarSize = size === 'sm' ? 'sm' : 'md';
  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`}>
      <Avatar name={name || '?'} src={avatarSrc} size={avatarSize} />
      <div className="min-w-0">
        <div className={`font-semibold truncate ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
          {name || '—'}
        </div>
        {subtitle && (
          <div className="text-[11px] text-slate-500 truncate">{subtitle}</div>
        )}
      </div>
    </div>
  );
};
